<template>
<div v-for="item in props.list" :key="item.id" class="position-relative product-item" >
	<div class="bg-white px-2 pt-1 rounded " >
    <!-- کلید روی محصول -->
		<button-template v-if="!item.store_active" :id="item.id" :sid="item.place_id || item.store_place_id" :quantity="item.quantity" origin="product" />
    <!-- فروشگاه بسته است -->
    <span v-else class="product-new-top bg-red w-100 rounded d-flex bg-secondary" style="height: 24px;justify-content: center;align-items: center;font-size: 12px;">فروشگاه بسته است</span>
		<div @click="goProductPage(item.id)"> 
			<figure class="sc-1q5lmzx-2 ktLvGN thumbnail-Wrapper" style="margin-bottom:.75em">
        <img :src="'https://radap.ir/'+item.img_url.split(',')[0]" class="product-img" :alt="item.stuff_name || item.name" loading="lazy" > 
        <span class="product-name">{{item.stuff_name || item.name }}</span> 
        <span class="product-description text-muted">{{item.description }}</span> 
      </figure>
    </div>
    <!-- قیمت محصول -->
		<footer class="">
    <!-- تخفیف اگر داشت -->
				<div :class="{'visible' : item.discount > 0 , 'invisible' : item.discount == 0 }">
					<div>
            <del class="small pe-1 text-muted">{{convertToPersian(numberFormat(item.price))}}</del> 
						<label class="p--5 product-discount" style="color: red;" :class="{'peculiar-discount' : item.discount > 4}">%{{convertToPersian(item.discount)}}</label> 
          </div> 
        </div>
          <div>
            <strong>{{convertToPersian(numberFormat((parseInt(removeCommos(item.price)) - (parseInt(removeCommos(item.price)) * (parseInt(item.discount) / 100)))))}}</strong>
            <small>تومان</small>
          </div>
		</footer>
	</div>
</div>
</template>
<script setup>
import { defineProps } from 'vue'
import ButtonTemplate from './button.vue'
import router from '@/router';
import { convertToPersian, numberFormat,removeCommos } from '@/composables/digits';
import { useModal } from '@/store/modal';
let props = defineProps(['list']);

const modalStore = useModal();

function goProductPage(id){
  modalStore.open('productModal')
  modalStore.paylode.id = id
  // router.push({name:'Single',params:{item:id}})
}
</script>
<style scoped>
@import "../../../assets/css/product.css";
.product-item{
  height: 200px;
}
.product-description{
    height: 22px;
    font-size: 11px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: black;
    font-family: "IranSans";
}
.product-img{
    max-height: 90px !important;
    min-height: 90px !important;
    max-width: 90px !important;
    min-width: 90px !important;
    margin-right: auto;
    margin-left: auto;
}
.product-discount{
  border: 1px solid red;
  line-height: 1.1;
  font-size: 12px;
  font-weight: 700;
  border-radius: 4px;
}
.p--5{
  padding: .25em .125em;
}
.product-item {
    width: 130px !important;
    min-width: 130px !important;
    max-width: 130px !important;
    margin-left: .5em !important;
}
</style>